import { render, staticRenderFns } from "./localizacion_representante.vue?vue&type=template&id=32d4f34f&"
import script from "./localizacion_representante.vue?vue&type=script&lang=js&"
export * from "./localizacion_representante.vue?vue&type=script&lang=js&"
import style0 from "./localizacion_representante.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports